import { render, staticRenderFns } from "./SaleModal.vue?vue&type=template&id=51057f81"
import script from "./SaleModal.vue?vue&type=script&lang=js"
export * from "./SaleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports